export function pingPrinter() {}

export function printImage() {}

export const LabelSize = {};
